module.exports = __webpack_public_path__ + "static/Inter-Regular-4f147571bec76460cbfcf0759add51ac.woff";